import { Component } from 'preact';

export default class Loader extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        const {isLoading, className = '', ariaHidden} = this.props;

        const classes = `paazl-delimiter loader${className ? ' ' + className : ''}`;

        return (
            isLoading && <div className={classes} aria-hidden={ariaHidden}></div>
        );
    }
}